export default __webpack_public_path__ + "static/media/gogetIconBlack.a1ae72d4.svg";